export default "__VITE_ASSET__roRCViHC__"